import { ForceDiscountSchema } from "@redotech/redo-marketing-common/agent-decision/force-discount";
import {
  VanguardDecision,
  WriterDecision,
} from "@redotech/redo-marketing-common/agent-decision/marketing-agent-decision-definition";
import { AvailableMarketingChannelSchema } from "@redotech/redo-marketing-common/channel-eligibility";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const generateMarketingAgentPreview = {
  name: "generateMarketingAgentPreview" as const,
  input: z.object({
    customerId: zExt.objectId(),
    availableChannels: z.array(AvailableMarketingChannelSchema).optional(),
    forceDiscount: ForceDiscountSchema.optional(),
  }),
  output: z.object({
    vanguardDecision: VanguardDecision,
    writerDecision: WriterDecision,
    vanguardThreadId: z.string(),
    writerThreadId: z.string(),
  }),
};
